import script from "./AccueilViras.vue?vue&type=script&setup=true&lang=js"
export * from "./AccueilViras.vue?vue&type=script&setup=true&lang=js"

import "./AccueilViras.vue?vue&type=style&index=0&id=134dafcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134dafcc"]])

export default __exports__